import { routes } from '@routes';
import { matchRoutes } from 'react-router-dom';

const routeObjects = Object.values(routes).map(({ pattern }) => ({ path: pattern }));

export const getOrganizationSlugFromPathname = (pathname: string): string | undefined =>
  matchRoutes(routeObjects, pathname)?.[0]?.params.orgSlug;
